export enum MembershipBenefitCardVariant {
	White = "White",
	Brown = "Brown",
	Blue = "Blue",
}
